import { AccessToken, AuthSession } from '../../../../types';

/**
 * A session with a first-factor token but no second-factor token yet. 2FA
 * enforcement stays user-data-gated (a user with twoFactorRequired=false is
 * fully authed on the jwt alone); this only records that the second factor has
 * not been obtained.
 */
export const awaitingTwoFactorSession = (
  jwt: AccessToken,
  expiresAt: string,
): AuthSession => ({
  status: 'awaiting-two-factor',
  jwt,
  expiresAt,
});
